// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"fff67182","59":"d8a59304","609":"ceded6cb","644":"f8a26f12","724":"4ac29c0b"}[chunkId] + ".chunk.js";
};